import { Helmet } from "react-helmet-async";
import maeveninsights from "../feature/maeveninsights.jpg";
import askanything from "../feature/askanything.webp";
import understandcustomers from "../feature/understandcustomers.webp";
import takeaction from "../feature/takeaction.webp";
import FeatureSection from "./FeatureSection";
import FeaturesBottom from "./FeaturesBottom";
import FeatureHeroSection from "./FeatureHeroSection";
import main from "../feature/maeven.webp";
import ContactIcon from "./ContactIcon";

function MaevenAI() {
  return (
    <>
      <Helmet>
        <title>Kadhr — Mæven AI Assistant</title>
        <meta
          name="description"
          content="Mæven is your built-in AI assistant that understands your business data. Ask questions, get instant answers, and take action immediately — no dashboards needed."
        />
      </Helmet>

      <main className="mtopcon0 ovrflwhdn" id="up">
        <ContactIcon />

        <div className="row">

          {/* HERO */}
          <FeatureHeroSection
            title="Run your business by asking"
            description="Mæven is your built-in AI assistant that understands your business data. Ask questions, get instant answers, and take action immediately — from identifying top customers to sending messages that drive repeat revenue. No dashboards to figure out. Just ask."
            image={main}
          />

          {/* FEATURES */}
          <div className="col-12 text-center mt-5 pt-6indx0" id="features">

            <FeatureSection
              title="Ask Anything About Your Business"
              description="“Who are my best customers this week?” “How much did I make today?” Mæven gives you answers instantly — no digging through dashboards."
              image={askanything}
              reverse
            />

            <FeatureSection
              title="Instant Insights, No Setup"
              description="Mæven analyzes your sales, customers, and behavior in real time — and explains it in simple, clear answers you can act on."
              image={maeveninsights}
            />

            <FeatureSection
              title="Take Action in One Command"
              description="Don’t just see insights — act on them. “Send a loyalty message to repeat customers” Mæven executes instantly."
              image={takeaction}
              reverse
            />

            <FeatureSection
              title="Understands Your Customers"
              description="Mæven uses your customer data — what they buy, how often they return — to suggest the right actions at the right time."
              image={understandcustomers}
            />

          </div>

          <div className="container mb-5">
                <div className="col-12 d-flex justify-content-center">
                    <div className="row feature-wrapper align-items-center feature-equal">

                    {/* TEXT */}
                    <div
                        className={`col-12 d-flex flex-column justify-content-center order-md-1 text-md-start card-border-right text-center`}
                    >
                        <h2 className="fw-bold text-center">What can you ask</h2>
                        <h2 className="fw-bold text-center"><span className="badge-retarget-fluid">Mæven?</span></h2>
                        <p className="text-muted mt-3 font90x"></p>
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <ul className="list-unstyled">
                                <li className="mb-2">• Who hasn’t bought in the last 30 days?</li>
                                <li className="mb-2">• Show me my top 10 customers</li>
                                <li className="mb-2">• Send a reminder to repeat buyers</li>
                                <li className="mb-2">• Which products drive the most revenue?</li>
                                <li className="mb-2">• Who is likely to return this week?</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    </div>
                </div>
            </div>

          <FeaturesBottom />

        </div>
      </main>
    </>
  );
}

export default MaevenAI;